const marketplaceReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_MARKETPLACE_SUCCESS":
      return action.payload
    case "GET_MARKETPLACE_GLOBAL_SUCCESS":
      return action.payload
    default:
      return state
  }
}

export default marketplaceReducer